const BACKGROUND_PALETTE = {
  transparent: {
    value: 'transparent',
    label: 'Transparent',
    hex: 'transparent'
  },
  white: {
    value: 'white',
    label: 'Weiß',
    hex: '#ffffff'
  },
  'gray-50': {
    value: 'gray-50',
    label: 'Grau 50',
    hex: '#f9fafb'
  },
  'gray-100': {
    value: 'gray-100',
    label: 'Grau 100',
    hex: '#f3f4f6'
  },
  'gray-200': {
    value: 'gray-200',
    label: 'Grau 200',
    hex: '#e5e7eb'
  },
  'gray-900': {
    value: 'gray-900',
    label: 'Grau 900',
    hex: '#111827'
  },
  'slate-50': {
    value: 'slate-50',
    label: 'Slate 50',
    hex: '#f8fafc'
  },
  'slate-600': {
    value: 'slate-600',
    label: 'Slate 600',
    hex: '#475569'
  },
  'slate-900': {
    value: 'slate-900',
    label: 'Slate 900',
    hex: '#0f172a'
  },
  'blue-50': {
    value: 'blue-50',
    label: 'Blau 50',
    hex: '#eff6ff'
  },
  'indigo-50': {
    value: 'indigo-50',
    label: 'Indigo 50',
    hex: '#eef2ff'
  },
  'green-50': {
    value: 'green-50',
    label: 'Grün 50',
    hex: '#f0fdf4'
  },
  'purple-50': {
    value: 'purple-50',
    label: 'Lila 50',
    hex: '#faf5ff'
  },
  'red-50': {
    value: 'red-50',
    label: 'Rot 50',
    hex: '#fef2f2'
  },
  'yellow-50': {
    value: 'yellow-50',
    label: 'Gelb 50',
    hex: '#fefce8'
  },
  'forest-green-50': {
    value: 'forest-green-50',
    label: 'Forest Green 50',
    hex: '#f1fcf1'
  },
  'forest-green-100': {
    value: 'forest-green-100',
    label: 'Forest Green 100',
    hex: '#e0f9df'
  },
  'forest-green-200': {
    value: 'forest-green-200',
    label: 'Forest Green 200',
    hex: '#c2f1c1'
  },
  'forest-green-300': {
    value: 'forest-green-300',
    label: 'Forest Green 300',
    hex: '#92e491'
  },
  'forest-green-400': {
    value: 'forest-green-400',
    label: 'Forest Green 400',
    hex: '#5acf59'
  },
  'forest-green-500': {
    value: 'forest-green-500',
    label: 'Forest Green 500',
    hex: '#34b433'
  },
  'forest-green-600': {
    value: 'forest-green-600',
    label: 'Forest Green 600',
    hex: '#228b22'
  },
  'forest-green-700': {
    value: 'forest-green-700',
    label: 'Forest Green 700',
    hex: '#207521'
  },
  'forest-green-800': {
    value: 'forest-green-800',
    label: 'Forest Green 800',
    hex: '#1e5d1f'
  },
  'forest-green-900': {
    value: 'forest-green-900',
    label: 'Forest Green 900',
    hex: '#1a4d1b'
  },
  'forest-green-950': {
    value: 'forest-green-950',
    label: 'Forest Green 950',
    hex: '#092a0b'
  },
  'motion-plum': {
    value: 'motion-plum',
    label: 'Motion Plum',
    hex: '#2e3542'
  },
  'motion-midnight': {
    value: 'motion-midnight',
    label: 'Motion Midnight',
    hex: '#12141a'
  },
  'motion-graphite': {
    value: 'motion-graphite',
    label: 'Motion Graphite',
    hex: '#0f1115'
  },
  'motion-blue': {
    value: 'motion-blue',
    label: 'Motion Blue',
    hex: '#0d63f8'
  },
  'motion-cyan': {
    value: 'motion-cyan',
    label: 'Motion Cyan',
    hex: '#0cdcf7'
  },
  'motion-lime': {
    value: 'motion-lime',
    label: 'Motion Lime',
    hex: '#4ff0b7'
  },
  'motion-pink': {
    value: 'motion-pink',
    label: 'Motion Pink',
    hex: '#ff4fba'
  },
  'blue-600': {
    value: 'blue-600',
    label: 'Blau 600',
    hex: '#2563eb'
  },
  'blue-700': {
    value: 'blue-700',
    label: 'Blau 700',
    hex: '#1d4ed8'
  },
  'indigo-600': {
    value: 'indigo-600',
    label: 'Indigo 600',
    hex: '#4f46e5'
  },
  'purple-600': {
    value: 'purple-600',
    label: 'Lila 600',
    hex: '#9333ea'
  },
  'green-600': {
    value: 'green-600',
    label: 'Grün 600',
    hex: '#16a34a'
  },
  'red-600': {
    value: 'red-600',
    label: 'Rot 600',
    hex: '#dc2626'
  },
  black: {
    value: 'black',
    label: 'Schwarz',
    hex: '#000000'
  },
  'gradient-soft': {
    value: 'gradient-soft',
    label: 'Gradient (hell)',
    hex: 'linear-gradient(to right, #f1f5f9, #ffffff, #f1f5f9)'
  },
  '#ffffff': { alias: 'white' },
  '#f8fafc': { alias: 'gray-50' },
  '#e2e8f0': { alias: 'gray-200' },
  '#475569': { alias: 'slate-600' },
  '#000000': { alias: 'black' },
  light: { alias: 'white' },
  gray: { alias: 'gray-50' },
  gradient: { alias: 'gradient-soft' },
  dark: { alias: 'slate-900' }
};

const TEXT_PALETTE = {
  'gray-400': {
    value: 'gray-400',
    label: 'Grau 400',
    hex: '#9ca3af'
  },
  'gray-500': {
    value: 'gray-500',
    label: 'Grau 500',
    hex: '#6b7280'
  },
  'gray-600': {
    value: 'gray-600',
    label: 'Grau 600',
    hex: '#4b5563'
  },
  white: {
    value: 'white',
    label: 'Weiß',
    hex: '#ffffff'
  },
  'blue-600': {
    value: 'blue-600',
    label: 'Blau 600',
    hex: '#2563eb'
  },
  'blue-700': {
    value: 'blue-700',
    label: 'Blau 700',
    hex: '#1d4ed8'
  },
  'indigo-600': {
    value: 'indigo-600',
    label: 'Indigo 600',
    hex: '#4f46e5'
  },
  'purple-600': {
    value: 'purple-600',
    label: 'Lila 600',
    hex: '#9333ea'
  },
  'green-600': {
    value: 'green-600',
    label: 'Grün 600',
    hex: '#16a34a'
  },
  'forest-green-50': {
    value: 'forest-green-50',
    label: 'Forest Green 50',
    hex: '#f1fcf1'
  },
  'forest-green-100': {
    value: 'forest-green-100',
    label: 'Forest Green 100',
    hex: '#e0f9df'
  },
  'forest-green-200': {
    value: 'forest-green-200',
    label: 'Forest Green 200',
    hex: '#c2f1c1'
  },
  'forest-green-300': {
    value: 'forest-green-300',
    label: 'Forest Green 300',
    hex: '#92e491'
  },
  'forest-green-400': {
    value: 'forest-green-400',
    label: 'Forest Green 400',
    hex: '#5acf59'
  },
  'forest-green-500': {
    value: 'forest-green-500',
    label: 'Forest Green 500',
    hex: '#34b433'
  },
  'forest-green-600': {
    value: 'forest-green-600',
    label: 'Forest Green 600',
    hex: '#228b22'
  },
  'forest-green-700': {
    value: 'forest-green-700',
    label: 'Forest Green 700',
    hex: '#207521'
  },
  'forest-green-800': {
    value: 'forest-green-800',
    label: 'Forest Green 800',
    hex: '#1e5d1f'
  },
  'forest-green-900': {
    value: 'forest-green-900',
    label: 'Forest Green 900',
    hex: '#1a4d1b'
  },
  'forest-green-950': {
    value: 'forest-green-950',
    label: 'Forest Green 950',
    hex: '#092a0b'
  },
  'motion-yellow': {
    value: 'motion-yellow',
    label: 'Motion Gelb',
    hex: '#fff312'
  },
  'motion-cyan': {
    value: 'motion-cyan',
    label: 'Motion Cyan',
    hex: '#0cdcf7'
  },
  'motion-lime': {
    value: 'motion-lime',
    label: 'Motion Lime',
    hex: '#4ff0b7'
  },
  'motion-pink': {
    value: 'motion-pink',
    label: 'Motion Pink',
    hex: '#ff4fba'
  },
  'motion-blue': {
    value: 'motion-blue',
    label: 'Motion Blau',
    hex: '#0d63f8'
  },
  'red-600': {
    value: 'red-600',
    label: 'Rot 600',
    hex: '#dc2626'
  },
  'gray-900': {
    value: 'gray-900',
    label: 'Grau 900',
    hex: '#111827'
  },
  'slate-900': {
    value: 'slate-900',
    label: 'Slate 900',
    hex: '#0f172a'
  },
  'slate-100': {
    value: 'slate-100',
    label: 'Slate 100',
    hex: '#f1f5f9'
  }
};

const ACCENT_PALETTE = {
  blue: {
    value: 'blue',
    label: 'Blau',
    textHex: '#2563eb',
    bgHex: '#eff6ff'
  },
  indigo: {
    value: 'indigo',
    label: 'Indigo',
    textHex: '#4f46e5',
    bgHex: '#eef2ff'
  },
  purple: {
    value: 'purple',
    label: 'Lila',
    textHex: '#9333ea',
    bgHex: '#faf5ff'
  },
  green: {
    value: 'green',
    label: 'Grün',
    textHex: '#16a34a',
    bgHex: '#f0fdf4'
  },
  amber: {
    value: 'amber',
    label: 'Amber',
    textHex: '#f59e0b',
    bgHex: '#fef3c7'
  },
  pink: {
    value: 'pink',
    label: 'Pink',
    textHex: '#db2777',
    bgHex: '#fce7f3'
  },
  'motion-yellow': {
    value: 'motion-yellow',
    label: 'Motion Gelb',
    textHex: '#fff312',
    bgHex: '#fff3121a'
  },
  'motion-cyan': {
    value: 'motion-cyan',
    label: 'Motion Cyan',
    textHex: '#0cdcf7',
    bgHex: '#0cdcf71a'
  },
  'motion-lime': {
    value: 'motion-lime',
    label: 'Motion Lime',
    textHex: '#4ff0b7',
    bgHex: '#4ff0b71a'
  },
  'motion-pink': {
    value: 'motion-pink',
    label: 'Motion Pink',
    textHex: '#ff4fba',
    bgHex: '#ff4fba1a'
  },
  'motion-blue': {
    value: 'motion-blue',
    label: 'Motion Blau',
    textHex: '#0d63f8',
    bgHex: '#0d63f81a'
  }
};

const resolveEntry = (palette, value, fallback, visited = new Set()) => {
  if (!value || visited.has(value)) {
    return palette[fallback] || null;
  }
  const entry = palette[value];
  if (!entry) {
    return palette[fallback] || null;
  }
  if (entry.alias) {
    visited.add(value);
    return resolveEntry(palette, entry.alias, fallback, visited);
  }
  return entry;
};

export const resolveBackgroundColor = (value, fallback = 'white') => {
  const entry = resolveEntry(BACKGROUND_PALETTE, value, fallback);
  if (!entry) {
    return { 
      className: '', 
      style: value ? { backgroundColor: value } : undefined,
      hex: value || '#ffffff'
    };
  }
  
  // Handle gradient backgrounds
  if (entry.hex && entry.hex.startsWith('linear-gradient')) {
    return {
      className: '',
      style: { background: entry.hex },
      hex: entry.hex
    };
  }
  
  return {
    className: '',
    style: { backgroundColor: entry.hex || entry.value || '#ffffff' },
    hex: entry.hex || entry.value || '#ffffff'
  };
};

export const resolveTextColor = (value, fallback = 'gray-500') => {
  const entry = resolveEntry(TEXT_PALETTE, value, fallback);
  if (!entry) {
    return { 
      className: '', 
      style: value ? { color: value } : undefined,
      hex: value || '#6b7280'
    };
  }
  return {
    className: '',
    style: { color: entry.hex || entry.value || '#6b7280' },
    hex: entry.hex || entry.value || '#6b7280'
  };
};

export const backgroundColorOptions = (keys) =>
  (keys || Object.keys(BACKGROUND_PALETTE))
    .map((key) => {
      const entry = resolveEntry(BACKGROUND_PALETTE, key, key);
      if (!entry) return null;
      return { label: entry.label, value: key };
    })
    .filter(Boolean);

export const textColorOptions = (keys) =>
  (keys || Object.keys(TEXT_PALETTE))
    .map((key) => {
      const entry = resolveEntry(TEXT_PALETTE, key, key);
      if (!entry) return null;
      return { label: entry.label, value: key };
    })
    .filter(Boolean);

export const BACKGROUND_COLOR_KEYS = Object.keys(BACKGROUND_PALETTE).filter(
  (key) => !BACKGROUND_PALETTE[key].alias
);

export const resolveAccentColor = (value, fallback = 'blue') => {
  const entry = resolveEntry(ACCENT_PALETTE, value, fallback);
  if (!entry) {
    return { 
      textClass: '', 
      bgClass: '', 
      style: value ? { color: value } : undefined,
      textHex: value || '#2563eb',
      bgHex: value || '#eff6ff'
    };
  }
  return {
    textClass: '',
    bgClass: '',
    style: { 
      color: entry.textHex || entry.value || '#2563eb',
      backgroundColor: entry.bgHex || entry.value || '#eff6ff'
    },
    textHex: entry.textHex || entry.value || '#2563eb',
    bgHex: entry.bgHex || entry.value || '#eff6ff'
  };
};

export const accentColorOptions = (keys) =>
  (keys || Object.keys(ACCENT_PALETTE))
    .map((key) => {
      const entry = resolveEntry(ACCENT_PALETTE, key, key);
      if (!entry) return null;
      return { label: entry.label, value: key };
    })
    .filter(Boolean);
